
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SpecialTime from './_SpecialTime.vue';
import { eRulesDialogContentStatus, eType } from '@/interface/backup-tactics';
@Component({
  components: {
    SpecialTime,
  },
})
export default class TimeRules extends Vue {
  @Prop() ruleInfo?: any;
  @Prop({ default: eRulesDialogContentStatus.INFO }) status!: string;
  private configStatus = eRulesDialogContentStatus;

  private checked = false;
  private disabled = false;
  private specialTimes = [{}];
  changeFreeTime(time: number) {
    this.ruleInfo.free_time = time;
  }
  changePeriod(time: number) {
    this.ruleInfo.billing_cycle = time;
  }

  mounted() {
    try {
      if (this.status === this.configStatus.CREATE) {
        this.disabled = false;
        this.checked = false;
      } else if (this.status === this.configStatus.INFO) {
        this.disabled = true;
        this.checked = true;
        if (this.ruleInfo.custom.length === 0) {
          this.checked = false;
        }
      } else if (this.status === this.configStatus.EDIT) {
        if (this.ruleInfo.type == eType.DEFAULT) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }

        this.checked = true;
        if (this.ruleInfo.custom.length === 0) {
          this.checked = false;
        }
      }
      this.specialTimes = this.ruleInfo.custom;
    } catch {}
  }

  @Watch('checked', { immediate: true })
  watchChecked(newVal: any) {
    this.$set(this.ruleInfo, 'checked', newVal);
    if (newVal && this.ruleInfo!.custom && this.ruleInfo!.custom.length === 0) {
      this.addSpecialTime();
    }
  }

  /**
   * 添加特殊时段
   */
  addSpecialTime() {
    this.specialTimes.push({
      backup_days: [],
      backup_periods: [
        {
          start: 0,
          end: 0,
          startStr: '',
          endStr: '',
        },
      ],
      backup_num: {
        low: { min: 0, max: 0 },
        high: { min: 0, max: 0 },
        free: { min: 0, max: 0 },
        lux: { min: 0, max: 0 },
      },
    });
  }
  delSpecialTime(index: number) {
    this.specialTimes.splice(index, 1);
  }
}
